import { toast, ToastOptions, Id } from 'react-toastify';
import errorService from './ErrorPopper';

const originalToast = {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warn: toast.warn,
    warning: toast.warning,
};

// Helper trả về dummy Id
const noopToast = (): Id => {
    // Tạo ID giả nếu toast bị chặn để TypeScript không báo lỗi
    return 'toast-suppressed' as Id;
};

export const patchToast = () => {
    toast.success = ((msg: any, options?: ToastOptions): Id => {
        return errorService.isPopupOpen()
            ? noopToast()
            : originalToast.success(msg, options);
    }) as typeof toast.success;

    toast.error = ((msg: any, options?: ToastOptions): Id => {
        return errorService.isPopupOpen()
            ? noopToast()
            : originalToast.error(msg, options);
    }) as typeof toast.error;

    toast.info = ((msg: any, options?: ToastOptions): Id => {
        return errorService.isPopupOpen()
            ? noopToast()
            : originalToast.info(msg, options);
    }) as typeof toast.info;

    toast.warn = ((msg: any, options?: ToastOptions): Id => {
        return errorService.isPopupOpen()
            ? noopToast()
            : originalToast.warn(msg, options);
    }) as typeof toast.warn;

    toast.warning = ((msg: any, options?: ToastOptions): Id => {
        return errorService.isPopupOpen()
            ? noopToast()
            : originalToast.warning(msg, options);
    }) as typeof toast.warning;
};
